import {
  MainContainer,
  CommitteeHeading,
  MemberImage,
  MembersContainer,
  Occupation,
  Name,
} from "./committeeStyles"
import React, { useState } from "react"
import { slice, concat } from "lodash"
import { useMediaQuery } from "react-responsive"
import { Loadmore } from "../ScientificSessions/sessionstyles"
import memberA from "../../images/c_member_1.jpg"
import member1 from "../../images/member1.jpg"
import member2 from "../../images/member2.jpg"
import member3 from "../../images/member3.jpg"
import member4 from "../../images/member4.jpg"
import member5 from "../../images/member5.jpg"
import member6 from "../../images/member6.jpg"
import member7 from "../../images/member7.jpg"
import member8 from "../../images/member8.jpg"
import member9 from "../../images/member9.jpg"
import Fade from "react-reveal/Fade"

const DATA = [
  { name: "Martina", occupation: "Developer", image: memberA },
  { name: "Martina", occupation: "Developer", image: member1 },
  { name: "Martina", occupation: "Developer", image: member2 },
  { name: "Martina", occupation: "Developer", image: member3 },
  { name: "Martina", occupation: "Developer", image: member4 },
  { name: "Martina", occupation: "Developer", image: member5 },
  { name: "Martina", occupation: "Developer", image: member6 },
  { name: "Martina", occupation: "Developer", image: member7 },
  { name: "Martina", occupation: "Developer", image: member8 },
  { name: "Martina", occupation: "Developer", image: member9 },
]

const CommitteeMembers = () => {
  const isMobile = useMediaQuery({
    query: "(max-device-width: 814px)",
  })

  const LIMIT = isMobile ? 4 : DATA.length

  const [showMore, setShowMore] = useState("View More")
  const [list, setList] = useState(slice(DATA, 0, LIMIT))

  const loadMore = () => {
    const newList = DATA

    setList(newList)
    setShowMore("View Less")
  }

  const viewLess = () => {
    const newList = slice(DATA, 0, LIMIT)
    setList(newList)
    setShowMore("View More")
    const elmnt = document.getElementById("governing")
    elmnt.scrollIntoView()
  }

  return (
    <>
      <MainContainer id="governing">
        <Fade up>
          <CommitteeHeading>Governing Body</CommitteeHeading>
        </Fade>

        <MembersContainer>
          {list.map(node => (
            <MemberImage image={node.image}>
              <Occupation>{node.occupation}</Occupation>
              <Name>{node.name}</Name>
            </MemberImage>
          ))}
        </MembersContainer>
        {isMobile && (
          <Loadmore
            style={{ margin: "40px auto" }}
            className="hvr-grow"
            onClick={showMore === "View More" ? loadMore : viewLess}
          >
            {showMore === "View More" ? "View More" : "View Less"}
          </Loadmore>
        )}
      </MainContainer>
    </>
  )
}

export default CommitteeMembers
